import styles from "@/components/forms/inputs/mandatoryMarker.module.css";

export const MandatoryMarker = () => (
  <span className={styles.mandatoryMarker}>*</span>
);
